import { t } from "i18next";
import {
  PrimaryButton,
  Icon,
  DirectionalHint,
  TooltipDelay,
} from "@fluentui/react";
import { FormikProvider, FieldArray, Field, getIn } from "formik";
import FormikTextField from "./FormikATextField";
import FormikSelectField from "./FormikSelectField";
import { ACTIONS } from "../../constants/Constants";
import CustomToolTipHost from "../CustomToolTipHost/CustomToolTipHost";
import FormikTagPicker from "./FormikTagPicker";

const Condition = (props) => {
  const toolTipStyles = {
    root: {
      height: "65%",
      display: "flex",
      alignItems: "center",
    },
  };
  const errorMessage = getIn(props.allErrors, props.name);
  return (
    <div key={props.name} className="ms-Grid" dir="ltr">
      {(props.action === ACTIONS.ADD || props.action === ACTIONS.EDIT) && (
        <FormikProvider value={props.formik}>
          <FieldArray
            name={props.name}
            render={(arrayHelpers) => (
              <div>
                {props.conditionList &&
                  props.conditionList.length > 0 &&
                  props.conditionList.map((condition, index) => (
                    <div
                      key={index}
                      className="ms-Grid-row"
                      style={index !== 0 ? { marginTop: "20px" } : {}}
                    >
                      <div
                        className="ms-Grid-col ms-sm3 ms-md3 ms-lg3 ms-xl3"
                        style={{ display: "flex", flexDirection: "column" }}
                      >
                        <div className="form-field">
                          <label className="ms-Label custom-label">
                            {t("hanging-protocol.tag")}
                            {props.required && <span className="required"> *</span>}
                          </label>
                          <Field
                            name={`${props.name}.${index}.tag`}
                            options={props.metaTagOptions}
                            value={condition.tag}
                            component={FormikSelectField}
                            autoFocus={
                              props.autoFocus === true && index === 0
                                ? true
                                : false
                            }
                            allErrors={props.allErrors}
                            placeholder={t("placeholder.select")}
                          />
                        </div>
                      </div>
                      <div
                        className="ms-Grid-col ms-sm2 ms-md2 ms-lg2 ms-xl2"
                        style={{ display: "flex", flexDirection: "column" }}
                      >
                        <div className="form-field">
                          <label className="ms-Label custom-label">
                            {t("hanging-protocol.operand")}
                            {props.required && <span className="required"> *</span>}
                          </label>
                          <Field
                            name={`${props.name}.${index}.operand`}
                            options={props.conditionOperandOptions}
                            value={condition.operand}
                            component={FormikSelectField}
                            allErrors={props.allErrors}
                            placeholder={t("placeholder.select")}
                          />
                        </div>
                      </div>
                      <div
                        className="ms-Grid-col ms-sm3 ms-md3 ms-lg3 ms-xl3"
                        style={{ display: "flex", flexDirection: "column" }}
                      >
                        <div className="form-field">
                          <label className="ms-Label custom-label">
                            {t("hanging-protocol.value")}
                            {props.required && <span className="required"> *</span>}
                          </label>
                          <Field
                            name={`${props.name}.${index}.value`}
                            value={Array.isArray(condition.value) ? condition.value : []}
                            placeholder={t("hanging-protocol.value")}
                            component={FormikTagPicker}
                            autoFocus={false}
                            allErrors={props.allErrors}
                          />
                        </div>
                      </div>
                      <div
                        className="ms-Grid-col ms-sm2=1 ms-md1 ms-lg1 ms-xl1"
                        style={{
                          height: "66px",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "flex-end",
                          alignItems: "center",
                        }}
                      >
                        <div className="form-field">
                          <CustomToolTipHost
                            delay={TooltipDelay.zero}
                            id={"delete-hp-condition"}
                            directionalHint={DirectionalHint.rightCenter}
                            styles={toolTipStyles}
                            content={t("hanging-protocol.delete") + props.type}
                            className={"myToolTip"}
                          >
                            <Icon
                              styles={{
                                root: {
                                  color:
                                    props.conditionList?.length > 1
                                      ? "#0078d4"
                                      : "#d0d0d0",
                                  cursor:
                                    props.conditionList?.length > 1
                                      ? "pointer"
                                      : "not-allowed",
                                  opacity:
                                    props.conditionList?.length > 1 ? 1 : 0.5, // Optional: Dim the icon when disabled
                                },
                              }}
                              iconName="Delete"
                              onClick={
                                props.conditionList?.length > 1
                                  ? () => arrayHelpers.remove(index)
                                  : undefined
                              }
                            />
                          </CustomToolTipHost>
                        </div>
                      </div>

                      {index !== props.conditionList.length - 1 && (
                        <div
                          className="ms-Grid-col ms-Label ms-Grid-col ms-sm2 ms-md2 ms-lg2 ms-xl2"
                          style={{
                            height: "66px",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "flex-end",
                          }}
                        >
                          AND
                        </div>
                      )}
                      {index === props.conditionList.length - 1 && (
                        <div
                          className="ms-Grid-col ms-Grid-col ms-sm2 ms-md2 ms-lg2 ms-xl2"
                          style={{
                            height: "66px",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "flex-end",
                          }}
                        >
                          <PrimaryButton
                            className="view-page-buttom"
                            style={{
                              width: "60%",
                            }}
                            text={
                              props.conditionList &&
                              props.conditionList.length > 0
                                ? t("hanging-protocol.add-more")
                                : t("hanging-protocol.add-condition")
                            }
                            onClick={() => {
                              arrayHelpers.push({
                                tag: "",
                                operand: "",
                                value: [""],
                              });
                            }}
                          />
                        </div>
                      )}
                    </div>
                  ))}
                {!Array.isArray(errorMessage) && (
                  <div role="alert" className="ms-Grid-row">
                    <p className="error-message">
                      <span>{errorMessage}</span>
                    </p>
                  </div>
                )}
                {/* <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
                  <PrimaryButton
                    className="view-page-button"
                    text={
                      props.conditionList && props.conditionList.length > 0
                        ? t("hanging-protocol.add-more")
                        : t("hanging-protocol.add-condition")
                    }
                    onClick={() => {
                      arrayHelpers.push({ tag: "", operand: "", value: "" });
                    }}
                  />
                </div> */}
              </div>
            )}
          />
        </FormikProvider>
      )}
      {props.action === ACTIONS.VIEW && (
        <div>
          {props.conditionList &&
            props.conditionList.length > 0 &&
            props.conditionList.map((condition, index) => (
              <div key={index}>
                <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
                  <div
                    className="ms-Grid-col ms-sm3 ms-md3 ms-lg3 ms-xl3"
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    <div className="form-heading">
                      {t("hanging-protocol.tag")}
                    </div>
                    <div className="form-mt-10">{condition.tagValue ?? '-'}</div>
                  </div>
                  <div
                    className="ms-Grid-col ms-sm2 ms-md2 ms-lg2 ms-xl2"
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    <div className="form-heading">
                      {t("hanging-protocol.operand")}
                    </div>
                    <div className="form-mt-10">{condition.operandValue ?? '-'}</div>
                  </div>
                  <div
                    className="ms-Grid-col ms-sm3 ms-md3 ms-lg3 ms-xl3"
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    <div className="form-heading">
                      {t("hanging-protocol.value")}
                    </div>
                    <div className="form-mt-10">
                      {Array.isArray(condition.value) && condition.value.length > 0
                        ? condition.value.join(", ")
                        : "-"}</div>
                  </div>
                  <div className="ms-Grid-col ms-sm4 ms-md4 ms-lg4 ms-xl4" />
                </div>
              </div>
            ))}
        </div>
      )}
    </div>
  );
};

export default Condition;
